import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import { useInscricoesTopicosNotificacaoContext } from './notificacao-context/useNotificacaoContext'

export function useNotificacaoStatus(tipoTopico: TipoTopicoNotificacaoEnum, id: ID): boolean {
  const inscricoesTopicos = useInscricoesTopicosNotificacaoContext()

  const notificacaoStatus = useMemo(() => {
    return inscricoesTopicos[tipoTopico]?.[id]?.statusNotificarLido ?? false
  }, [inscricoesTopicos, tipoTopico, id])

  return notificacaoStatus
}
